import { AppleButton as UiAppleButton, type AppleButtonProps } from "@hamlak/ui";
import { t } from "@/i18n/ko";

type Props = Omit<AppleButtonProps, "children">;

/** Apple 로그인 버튼(F01-02a). 문구는 i18n, 모양은 @hamlak/ui AppleButton(HIG 검정). Google 버튼 아래에 둔다. */
export function AppleButton(props: Props) {
  return (
    <UiAppleButton block {...props}>
      {t("login.apple")}
    </UiAppleButton>
  );
}
